/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
// React
import { Col, Input, Label, Row, Button } from 'reactstrap';
import React, { useMemo, useState, useEffect, useCallback } from 'react';

// Containers Injections & Components
import { ModalDepartment } from './component/ModalDepartment';
import {
  Currency,
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../containers/componentsInjection';

// Helpers
import { createData } from '../../../../../../utils/createData';
import { APIClient } from '../../../../../../helpers/api_helper';

export const GeneralInfo = ({
  isView,
  offices,
  plansData,
  validation,
  showEmployment,
  showMembership,
  showOrganization,
  setShowEmployment,
  categoryPlansData,
  setShowMembership,
  organizationsData,
  setShowOrganization,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const api = new APIClient();

  const planInput = validation.values?.planInput?.value;
  const categoryPlanInput = validation.values?.categoryPlanInput?.value;
  const organizationInput = validation.values?.organizationInput?.value;

  const dataSituationInput = useMemo(
    () => [
      {
        value: '1',
        label: 'Contratado',
      },
      {
        value: '2',
        label: 'Efetivo',
      },
      {
        value: '3',
        label: 'Aposentado',
      },
      {
        value: '4',
        label: 'Cancelado',
      },
      {
        value: '5',
        label: 'Inativo',
      },
    ],
    []
  );

  // Toggles
  function toggleDepartment() {
    setIsModalOpen(!isModalOpen);
  }

  // Functions

  const clearFields = (fields) => {
    fields.forEach((field) => {
      validation.setFieldValue(field, '');
    });
  };

  /**
   * function to create custom data for select input
   * based on data passing as props and search for id
   */
  const createDataById = (data, id) => {
    let newData = data.map((item) => {
      if (item.plan_category_id === id) {
        return {
          value: item.id,
          label: item.name,
        };
      }
    });

    return newData.filter(Boolean);
  };

  /**
   * function to verify if category plans has a show_organization/show_employment_details as true
   * or plans has a show_membership_fee as true
   */
  const verifyIfShowInputs = useCallback(
    (id, data, fieldKey, fieldsToClear, setShowFunction) => {
      const selectedItem = data?.find((item) => item.id === id);

      if (selectedItem?.[fieldKey]) {
        setShowFunction(true);
      } else {
        setShowFunction(false);
        clearFields(fieldsToClear);
      }
    },
    []
  );

  const resetPlanInput = () => {
    // showMembership depend of plan selected, if don't have plan so membership should set to false
    setShowMembership(false);

    if (validation.values.planInput) {
      validation.handleChange({
        target: {
          name: 'planInput',
          value: {
            label: '',
            value: '',
          },
        },
      });
    }
  };

  const resetDepartmentInput = () => {
    if (validation.values.department) {
      validation.handleChange({
        target: {
          name: 'department',
          value: {
            label: '',
            value: '',
          },
        },
      });
    }
  };

  const handleChangeCategoryPlanInput = (eventInput) => {
    verifyIfShowInputs(
      eventInput.value,
      categoryPlansData,
      'show_organization',
      ['organizationInput', 'department', 'secretary'],
      setShowOrganization
    );
    verifyIfShowInputs(
      eventInput.value,
      categoryPlansData,
      'show_employment_details',
      ['situationInput', 'validContractWorkInput', 'registrationInput'],
      setShowEmployment
    );

    resetPlanInput();

    validation.handleChange(
      convertEventSelectToTarget('categoryPlanInput', eventInput)
    );
  };

  const handleChangePlanInput = (eventInput) => {
    verifyIfShowInputs(
      eventInput.value,
      plansData,
      'show_membership_fee',
      ['membershipInput'],
      setShowMembership
    );

    validation.handleChange(
      convertEventSelectToTarget('planInput', eventInput)
    );
  };

  // GET calls
  const getValueOfSituation = useCallback(() => {
    if (typeof validation.values.situationInput === 'string') {
      const data = dataSituationInput.filter((item) => {
        if (validation.values.situationInput === item.value) {
          return item;
        }
      });

      return data;
    } else {
      const data = dataSituationInput.filter((item) => {
        if (validation.values.situationInput.value === item.value) {
          return item;
        }
      });

      return data;
    }
  }, [dataSituationInput, validation.values.situationInput]);

  const getOptionsToDepartmentInput = useCallback(async (idOrganization) => {
    await api
      .get(`/register/unit/find-by-organization/${idOrganization}`)
      .then((options) => {
        if (options) {
          let data = [];
          options.map((option) => {
            return data.push({
              label: option.name,
              value: option.id,
            });
          });
          setDepartmentOptions(data);
        }
      });
  }, []);

  useEffect(() => {
    if (
      categoryPlanInput !== null ||
      planInput !== null ||
      organizationInput !== null
    ) {
      verifyIfShowInputs(
        categoryPlanInput,
        categoryPlansData,
        'show_organization',
        ['organizationInput', 'department', 'secretary'],
        setShowOrganization
      );

      verifyIfShowInputs(
        categoryPlanInput,
        categoryPlansData,
        'show_employment_details',
        ['situationInput', 'validContractWorkInput', 'registrationInput'],
        setShowEmployment
      );

      verifyIfShowInputs(
        planInput,
        plansData,
        'show_membership_fee',
        ['membershipInput'],
        setShowMembership
      );
    }
  }, [planInput, categoryPlanInput, organizationInput]);

  useEffect(() => {
    if (organizationInput) {
      getOptionsToDepartmentInput(organizationInput);
    }
  }, [getOptionsToDepartmentInput, organizationInput]);

  return (
    <Row>
      <Col md={12}>
        <Col md={12} className="mb-3">
          <p className="h4"> Informações gerais</p>
        </Col>
        <Row>
          <Col md={3} className="mb-3">
            <Label
              for="categoryPlanInput"
              className="text-muted text-uppercase fw-semibold"
            >
              Categoria do plano
            </Label>
            <SelectInput
              invalid={
                !!(
                  validation.touched.categoryPlanInput &&
                  validation.errors.categoryPlanInput
                )
              }
              options={createData(categoryPlansData)}
              value={validation.values.categoryPlanInput}
              onChange={handleChangeCategoryPlanInput}
              onBlur={(eventInput) => {
                validation.handleBlur(
                  convertEventSelectToTarget('categoryPlanInput', eventInput)
                );
              }}
              isDisabled={isView}
              className="form-control bg-light border-0"
              inputId="categoryPlanInput"
            />
          </Col>
          <Col md={3} className="mb-3">
            <Label
              for="planInput"
              className="text-muted text-uppercase fw-semibold"
            >
              Plano
            </Label>
            <SelectInput
              isDisabled={
                validation.values.categoryPlanInput.value === null || isView
              }
              value={validation.values.planInput}
              className="form-control bg-light border-0"
              invalid={
                !!(validation.touched.planInput && validation.errors.planInput)
              }
              onChange={handleChangePlanInput}
              onBlur={(eventInput) => {
                validation.handleBlur(
                  convertEventSelectToTarget('planInput', eventInput)
                );
              }}
              options={createDataById(
                plansData,
                validation.values.categoryPlanInput.value
              )}
              inputId="planInput"
            />
          </Col>

          <Col md={2} className="mb-3">
            <div>
              <Label
                for="saleAtInput"
                className="text-muted text-uppercase fw-semibold"
              >
                Data da Venda
              </Label>
              <Input
                className="form-control bg-light border-0"
                type="date"
                id="saleAtInput"
                disabled={isView}
                value={validation.values.saleAtInput}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                invalid={
                  !!(
                    validation.touched.saleAtInput &&
                    validation.errors.saleAtInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={2} className="mb-3">
            <div>
              <Label
                for="effectiveDateInput"
                className="text-muted text-uppercase fw-semibold"
              >
                Data da Vigência
              </Label>
              <Input
                className="form-control bg-light border-0"
                type="date"
                id="effectiveDateInput"
                disabled={isView}
                value={validation.values.effectiveDateInput}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                invalid={
                  !!(
                    validation.touched.effectiveDateInput &&
                    validation.errors.effectiveDateInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={2} className="mb-3">
            <Label
              for="validInput"
              className="text-muted text-uppercase fw-semibold"
            >
              Data da Renovação
            </Label>
            <Input
              className="form-control bg-light border-0"
              type="date"
              id="validInput"
              disabled={isView}
              value={validation.values.validInput}
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              invalid={
                !!(
                  validation.touched.validInput && validation.errors.validInput
                )
              }
            />
          </Col>
        </Row>
        <Row>
          {showOrganization && (
            <>
              <Col md={6} className="mb-3">
                <Label
                  for="organizationInput"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Organização
                </Label>
                <SelectInput
                  invalid={
                    !!(
                      validation.touched.organizationInput &&
                      validation.errors.organizationInput
                    )
                  }
                  options={createData(organizationsData)}
                  isDisabled={isView}
                  value={validation.values.organizationInput}
                  onChange={(eventInput) => {
                    resetDepartmentInput();

                    validation.handleChange(
                      convertEventSelectToTarget(
                        'organizationInput',
                        eventInput
                      )
                    );
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget(
                        'organizationInput',
                        eventInput
                      )
                    );
                  }}
                  className="form-control bg-light border-0"
                  inputId="organizationInput"
                />
              </Col>

              <Col md={6} className="mb-3">
                <Label
                  for="department"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Lotação
                </Label>

                <div className="d-flex justify-content-center align-items-center">
                  <SelectInput
                    isDisabled={
                      validation.values.organizationInput.value === null ||
                      isView
                    }
                    inputId="department"
                    className="form-control bg-light border-0"
                    invalid={
                      !!(
                        validation.touched.department &&
                        validation.errors.department
                      )
                    }
                    options={departmentOptions}
                    value={validation.values.department}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('department', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('department', eventInput)
                      );
                    }}
                  />

                  <button
                    type="button"
                    onClick={() => toggleDepartment()}
                    className="btn btn-soft-primary btn-sm custom-toggle active"
                    disabled={
                      validation.values.organizationInput.value === null ||
                      isView
                    }
                    style={{
                      marginLeft:
                        '10px                                          ',
                    }}
                  >
                    <i className="ri-add-line" />
                  </button>
                </div>

                <ModalDepartment
                  api={api}
                  isOpen={isModalOpen}
                  toggle={toggleDepartment}
                  validationDepartment={validation}
                  idOrganization={validation.values.organizationInput.value}
                />
              </Col>

              <Col md={4} className="mb-3">
                <Label
                  for="secretary"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Secretaria
                </Label>
                <Input
                  className="form-control bg-light border-0"
                  type="text"
                  id="secretary"
                  name="secretary"
                  disabled={isView}
                  onBlur={validation.handleBlur}
                  value={validation.values.secretary}
                  onChange={(e) => validation.handleChange(e)}
                />
              </Col>
            </>
          )}
          {showEmployment && (
            <>
              <Col md={4} className="mb-3">
                <Label
                  for="situationInput"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Situação cadastral
                </Label>
                <SelectInput
                  value={getValueOfSituation()}
                  className="form-control bg-light border-0"
                  isDisabled={isView}
                  invalid={
                    !!(
                      validation.touched.situationInput &&
                      validation.errors.situationInput
                    )
                  }
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget('situationInput', eventInput)
                    );
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget('situationInput', eventInput)
                    );
                  }}
                  options={dataSituationInput}
                  inputId="situationInput"
                />
              </Col>
              <Col className="mb-3" md={4}>
                <Label
                  for="validContractWorkInput"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Vencimento Contrato de Trabalho
                </Label>
                <Input
                  className="form-control bg-light border-0"
                  type="date"
                  id="validContractWorkInput"
                  disabled={isView}
                  value={validation.values.validContractWorkInput}
                  onBlur={validation.handleBlur}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.validContractWorkInput &&
                      validation.errors.validContractWorkInput
                    )
                  }
                />
              </Col>
              <Col md={4} className="mb-3">
                <Label
                  for="registrationInput"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Matricula
                </Label>
                <Input
                  className="form-control bg-light border-0"
                  type="text"
                  id="registrationInput"
                  value={validation.values.registrationInput}
                  disabled={isView}
                  onBlur={validation.handleBlur}
                  onChange={(e) => validation.handleChange(e)}
                  invalid={
                    !!(
                      validation.touched.registrationInput &&
                      validation.errors.registrationInput
                    )
                  }
                />
              </Col>
            </>
          )}
        </Row>
        <Col className="mb-3">
          <Label
            for="obsInput"
            className="text-muted text-uppercase fw-semibold"
          >
            Observações
          </Label>
          <Input
            className="form-control bg-light border-0"
            aria-multiline
            type="textarea"
            id="obsInput"
            style={{
              height: 100,
            }}
            disabled={isView}
            value={validation.values.obsInput}
            onBlur={validation.handleBlur}
            onChange={(e) => validation.handleChange(e)}
            invalid={
              !!(validation.touched.obsInput && validation.errors.obsInput)
            }
          />
        </Col>
        <Col className="mb-3">
          <Input
            className="me-2"
            type="checkbox"
            id="funeralAssistanceInput"
            name="funeralAssistance"
            disabled={isView}
            value={validation.values.funeralAssistance}
            checked={validation.values.funeralAssistance}
            onBlur={validation.handleBlur}
            onChange={(e) => validation.handleChange(e)}
            invalid={
              !!(
                validation.touched.funeralAssistance &&
                validation.errors.funeralAssistance
              )
            }
          />
          <Label
            for="funeralAssistanceInput"
            className="text-muted text-uppercase"
          >
            Assistência funerária
          </Label>
        </Col>

        {showMembership && (
          <Row>
            <Col md={10} />
            <Col md={2} className="text-end">
              <Col>
                <Label
                  for="obsInput"
                  className="text-muted text-uppercase fw-semibold"
                >
                  Taxa de adesão
                </Label>
                <Currency
                  className="form-control bg-light border-0 text-end"
                  id="membershipInput"
                  value={validation.values.membershipInput}
                  disabled={isView}
                  onChange={(_, valueWithoutMask) => {
                    validation.handleChange({
                      target: {
                        name: 'membershipInput',
                        value: valueWithoutMask,
                      },
                    });
                  }}
                  invalid={
                    !!(
                      validation.touched.membershipInput &&
                      validation.errors.membershipInput
                    )
                  }
                />
              </Col>
            </Col>
          </Row>
        )}

        <Col className="mb-3" xs={4} md={4} lg={4}>
          <Label
            for="officeInput"
            className="text-muted text-uppercase fw-semibold"
          >
            Escritório
          </Label>
          <SelectInput
            isDisabled={isView}
            inputId="officeInput"
            className="form-control bg-light border-0"
            options={createData(offices)}
            value={validation.values.officeInput}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('officeInput', eventInput)
              );
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('officeInput', eventInput)
              );
            }}
            invalid={
              !!(
                validation.touched.officeInput && validation.errors.officeInput
              )
            }
          />
        </Col>
      </Col>
    </Row>
  );
};
